import {DrillHoleConfiguration} from "@/Models/DrillHoleConfigurations/DrillHoleConfiguration";

export default class GridDrillHoleConfiguration implements DrillHoleConfiguration {
	get_input_keys(): string[] {
		return [
			'drillHoleDiameter',
			'drillHoleOffset',
			'drillHoleHorizontalAmount',
			'drillHoleVerticalAmount',
		];
	}
}
